import { __rest } from "tslib";
import React from 'react';
import { Box, Grid, Typography } from '@material-ui/core';
export const Title = (props) => {
    const { dataQa, title, style } = props, rest = __rest(props, ["dataQa", "title", "style"]);
    return (React.createElement(Grid, { container: true, spacing: 2, direction: "column", justify: "space-between" },
        React.createElement(Grid, { item: true },
            React.createElement(Box, { "data-qa": dataQa },
                React.createElement(Typography, Object.assign({}, rest, { style: style }), title)))));
};
export default Title;
